import styled from "styled-components";

export const ChartContainer = styled.div<{ $isDialog: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing.small};
  width: 100%;
  position: relative;
  align-items: center;
  border-radius: 8px;
  padding: ${({ theme }) => theme.spacing.small};
  border: ${({ $isDialog, theme }) =>
    $isDialog ? "none" : `1px solid ${theme.colors.borderColor}`};
  background: ${({ theme }) => theme.colors.background};

  h3 {
    margin: 0;
    width: 100%;
    text-align: center;
    font-size: 1.1rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const LegendBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.5rem 0.875rem;
  width: 100%;
  // padding: 0 1rem 0.2rem;
  overflow: hidden;
`;

export const LegendItem = styled.button<{ $hidden: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border: none;
  background: transparent;
  padding: 0.1rem 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textSecondary};
  opacity: ${({ $hidden }) => ($hidden ? 0.45 : 1)};
  text-decoration: ${({ $hidden }) => ($hidden ? "line-through" : "none")};
  font-size: 0.9rem;

  &:hover {
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const LegendMarker = styled.span<{ $color: string; $hidden: boolean }>`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 999px;
  background: ${({ $color }) => $color};
  opacity: ${({ $hidden }) => ($hidden ? 0.45 : 1)};
  flex: 0 0 auto;
`;

export const ChartSurface = styled.div<{ $visible: boolean }>`
  display: ${({ $visible }) => ($visible ? "block" : "none")};
  // visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  // opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  // pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};

  flex: 1;
  width: 100%;
  min-height: clamp(260px, 29.85vh, 750px);
  background: transparent;
  overscroll-behavior: contain;
  touch-action: none;

  canvas {
    background-color: ${({ theme }) => theme.colors.background} !important;
  }

  @media screen and (max-width: 1850px) {
    min-height: clamp(275px, 28vh, 750px);
  }
  @media screen and (max-width: 1700px) {
    min-height: clamp(275px, 27vh, 750px);
  }
  @media screen and (max-width: 1550px) {
    min-height: clamp(275px, 24vh, 750px);
  }
  @media screen and (max-width: 1100px) {
    min-height: 300px;
  }
`;

export const NoDataMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 275px;
  color: #adb5bd;
  font-size: 1rem;
`;

export const CloseButton = styled.span<{ $isDialog: boolean }>`
  display: ${({ $isDialog }) => ($isDialog ? "none" : "block")};
  position: absolute;
  top: 0.25rem;
  right: 0.5rem;
  color: ${({ theme }) => theme.colors.mediumGrey};
  cursor: pointer;
  padding: 0.5rem;

  :hover {
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const OpenButton = styled.span`
  position: absolute;
  top: 0.25rem;
  right: 2.25rem;
  color: ${({ theme }) => theme.colors.mediumGrey};
  cursor: pointer;
  padding: 0.5rem;

  :hover {
    color: ${({ theme }) => theme.colors.text};
  }
`;
